export default "__VITE_ASSET__fWXxt1wn__"